import { createFileRoute } from '@tanstack/react-router'
import { ReleaseNotesPage } from '@/components/ReleaseNotes/ReleaseNotesPage'
import { PublicPageSeo } from '@/modules/seo'

function UpdateDetailPage() {
  const { slug } = Route.useParams()
  return (
    <>
      <PublicPageSeo pageId='updateDetail' pathOverride={`/updates/${slug}`} />
      <ReleaseNotesPage scrollToSlug={slug} />
    </>
  )
}

export const Route = createFileRoute('/updates/$slug')({
  component: UpdateDetailPage,
})
